<template>
  <div class="result_area_viewPage">
    <div class="result_centent_viewPage">
      <div :class="'result_viewPage '+ result.type+'_viewPage'">
        <Icon v-if="result.type=='success'" type="md-checkmark" size="70" color="#ffffff" />
        <Icon v-if="result.type=='error'" type="md-close" size="70" color="#ffffff" />
      </div>
      <div class="title_viewPage">
        {{result.title}} <span v-if="isPerson">
          ，请联系单位继续申报
        </span>
      </div>
      <div class="desc_viewPage" v-if="!isPerson">
        您的申请已提交<span v-show="result.desc">，流水号为：{{result.desc}}</span>
      </div>
      <div class="actions_viewPage">
        <Button type="primary" @click="backList">返回列表</Button>
      </div>
    </div>

    <!-- <template #desc>
      您的申请已提交，流水号为：{{result.desc}}
    </template> -->
    <!-- <template #actions>
      <Button type="primary" @click="backList">返回列表</Button>
    </template> -->
  </div>
</template>
<script>
export default {
  props: { result: Object, resContent: String, isPerson: Boolean },

  methods: {
    backList() {
      this.$router.push({ path: '/myApplications' })
    },
  },
}
</script>